import { Selectors } from "../Selectors";
import { FaceDetectionControllerFr } from "./FaceDetectionControllerFr";

export class ModalControllerFr {

    constructor(private webcam: any) { }

    public init(faceDetectionController: FaceDetectionControllerFr) {
        this.initModal();
        this.initModalActions(faceDetectionController);
    }

    private initModal() {
        let that = this;
        // $(Selectors.modalSelector).on('hide.bs.modal', function (e) {
        //     that.webcam.stop();
        //     $(Selectors.camContainerSelector).children().last().remove();  
        // })
    }

    private initModalActions(faceDetectionController: FaceDetectionControllerFr) {
        let that = this;
        $(Selectors.buttonInitRegisterSelector).on( 'click', function(e){
            e.preventDefault();
            $(Selectors.errorWebcamContainerSelector).hide();
            $(Selectors.msgContainerSelector).show();
            $(Selectors.camRegisterContainerSelector).hide();
            $(Selectors.modalOverlaySelector).show();
            $(Selectors.modalSelector).show();
        });


        $(`${Selectors.modalSelector} .modal-close`).click(function(event) {
            $(Selectors.modalSelector).fadeOut(400, function(){
                $(Selectors.modalOverlaySelector).hide();
                if(!faceDetectionController.alreadyRegistered){
                    faceDetectionController.stopWebcam();
                    faceDetectionController.reInitScan();
                }
            });
        });
    
        $(Selectors.initScanBtnSelector).on( 'click', function(e){
            e.preventDefault();
            $(Selectors.errorWebcamContainerSelector).hide();
            that.webcam.start()
                .then((result: any) =>{
                    console.log("webcam started");
                    $(Selectors.errorWebcamContainerSelector).hide();
                    $(Selectors.msgContainerSelector).hide();
                    $(`${Selectors.generalStepSelector}1`).show();
                    $(Selectors.registroPorcentajeSelector).text("0%");
                    $(Selectors.camRegisterContainerSelector).show();
                })
                .catch((err: any) => {
                    console.log(err);
                    $(Selectors.msgContainerSelector).hide();
                    $(Selectors.errorWebcamContainerSelector).fadeIn();
                });
        });
    }
}
